import $ from 'jquery'
import UMasonry from "./UMasonry";

const swapTriggerText = (trigger, label) => {
  if (trigger && label) {
    const span = trigger.querySelector("span")
    const target = span ? span : trigger
    target.innerHTML = label
  }
}
const getTriggerReferenceBoxes = (trigger) => {
  let arr = []
  const id = trigger.dataset.id
  const wrapper = id ? document.getElementById(id) : null
  if (wrapper) {
    arr = [...wrapper.querySelectorAll(".masonry-item")]
  }
  return arr
}
const getTriggerListWrapper = (trigger) => {
  const listId = trigger.dataset.listWrapperId
  return listId ? document.getElementById(listId) : null
}
// zmieniła się liczba elementów kontenera (masonry?)
const listWrapperUpdateState = (listWrapper) => {
  if (listWrapper && listWrapper.classList.contains("masonry-loader")) {
    UMasonry.refreshMasonry(0, $(listWrapper))
  }
}
const clearBoxAddOns = (listWrapper) => {
  const list = [...listWrapper.querySelectorAll(".boxAddOn")]
  list.forEach((el, index) => {
    listWrapper.removeChild(el)
    listWrapperUpdateState(listWrapper)
  });
}
const boxesCollapseShow = (trigger) => {
  trigger.classList.add("show")
  swapTriggerText(trigger, trigger.dataset.labelExpanded)
  const listWrapper = getTriggerListWrapper(trigger)
  if (listWrapper) {
    clearBoxAddOns(listWrapper)
    getTriggerReferenceBoxes(trigger).forEach((node, index) => {
      const box = node.cloneNode(true)
      box.classList.add("boxAddOn")
      listWrapper.appendChild(box)
      listWrapperUpdateState(listWrapper)
    })
  }
}
const boxesCollapseHide = (trigger) => {
  trigger.classList.remove("show")
  swapTriggerText(trigger, trigger.dataset.labelCollapsed)
  const listWrapper = getTriggerListWrapper(trigger)
  if (listWrapper) {
    clearBoxAddOns(listWrapper)
  }
}

const onToggleBoxesClick = (e) => {
  e.preventDefault();
  if (e.currentTarget.classList.contains("show")) {
    boxesCollapseHide(e.currentTarget)
  } else {
    boxesCollapseShow(e.currentTarget)
  }
}

export const initBoxesCollapse = () => {
  $('body').on("click", "a.toggle-boxes-collapse", onToggleBoxesClick)
}